import { render, staticRenderFns } from "./sidebar-clinique.html?vue&type=template&id=ddbaa5fc&scoped=true&external"
import script from "./sidebar-clinique.js?vue&type=script&lang=js&external"
export * from "./sidebar-clinique.js?vue&type=script&lang=js&external"
import style0 from "./sidebar-clinique.scss?vue&type=style&index=0&id=ddbaa5fc&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddbaa5fc",
  null
  
)

export default component.exports